import { Option } from "api/types/_public";

export const SCHEDULE_OPTIONS: Option[] = [
  {
    label: "Now",
    value: "now",
  },
  {
    label: "Daily",
    value: "daily",
  },
  {
    label: "Weekly",
    value: "weekly",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
];

export const SCHEDULE_MONTHLY_OPTIONS: Option[] = Array.from(
  { length: 31 },
  (_, index) => {
    const day = (index + 1).toString().padStart(2, "0");
    return { label: `${day}th`, value: day };
  }
);

export const ARR_INDEX_TEXT_DAY_OF_WEEK: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const SCHEDULE_WEEKLY_OPTIONS: Option[] = [
  {
    label: "Monday",
    value: "1",
  },
  {
    label: "Tuesday",
    value: "2",
  },
  {
    label: "Wednesday",
    value: "3",
  },
  {
    label: "Thursday",
    value: "4",
  },
  {
    label: "Friday",
    value: "5",
  },
  {
    label: "Saturday",
    value: "6",
  },
  {
    label: "Sunday",
    value: "7",
  },
];

export const TYPE_SHOW_MORE_HASHTAG = {
  SCROLL: 'scroll',
  MODAL: 'modal'
}

export const FREQUENCY_TYPE: any = {
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3,
};

export enum TYPE_BANNER_ADVERTISING {
  SINGLE_BANNER = 1,
  SLIDE_BANNER = 2,
};


export enum UPLOAD_ACTION {
  DEFAULT = 0,
  MAILER_CONTENT = 10,
  MAILER_ATTACHMENT = 11,
  NEWS_CONTENT = 12,
  APPTECH = 20,
  GOLD_PRICE = 30,
  VOTE_KEYWORD = 40,
}

export const COLORS_SECTION_KEYWORD: any = {
  '100': 'success',
  '200': 'danger',
  '201': 'primary',
  '202': 'warning',
  '203': 'green',
  '204': 'secondary',
  '205': 'purple',
  '206': 'pink',
  '207': 'info',
  '300': 'dark'
};


export enum SECTION_KEYWORD {
  GOOGLE_TREND = 100,
  NAVER_POLITICS = 200,
  NAVER_ECONOMY = 201,
  NAVER_SOCIETY = 202,
  NAVER_LIFE_CULTURE = 203,
  NAVER_IT_SCIENCE = 204,
  NAVER_WORLD = 205,
  NAVER_ENTERTAIN = 206,
  NAVER_SPORT = 207,
  BOOSTING = 300,
  REAL_TIME = 400,
  MANUAL = 501
}

export const SECTION_KEYWORD_OPTIONS: Option[] = [
  {
    label: `Google`,
    value: String(SECTION_KEYWORD.GOOGLE_TREND),
  },
  {
    label: `Politics`,
    value: String(SECTION_KEYWORD.NAVER_POLITICS),
  },
  {
    label: `Economy`,
    value: String(SECTION_KEYWORD.NAVER_ECONOMY),
  },
  {
    label: `Society`,
    value: String(SECTION_KEYWORD.NAVER_SOCIETY),
  },
  {
    label: `Life/Culture`,
    value: String(SECTION_KEYWORD.NAVER_LIFE_CULTURE),
  },
  {
    label: `IT/Science`,
    value: String(SECTION_KEYWORD.NAVER_IT_SCIENCE),
  },
  {
    label: `World`,
    value: String(SECTION_KEYWORD.NAVER_WORLD),
  },
  {
    label: `Entertainment`,
    value: String(SECTION_KEYWORD.NAVER_ENTERTAIN),
  },
  {
    label: `Sports`,
    value: String(SECTION_KEYWORD.NAVER_SPORT),
  },
  // {
  //   label: `Boosting`,
  //   value: String(SECTION_KEYWORD.BOOSTING)
  // }
];

export enum NEWS_TAB {
  AI_NEWS = '1',
  BOOSTING_NEWS = '2',
  AI_CUSTOM_NEWS = '3',
}

export const TYPE_NEWS_OPTIONS: Option[] = [
  {
    label: `AI News`,
    value: NEWS_TAB.AI_NEWS,
  },
  {
    label: `Boosting News`,
    value: NEWS_TAB.BOOSTING_NEWS,
  },
  {
    label: `AI Custom News`,
    value: NEWS_TAB.AI_CUSTOM_NEWS,
  }
];


export enum ENUM_STATUS_NEWS {
  USED = 1,
  UNUSED = 0,
};

export const COLORS_STATUS_NEWS: any = {
  '0': 'success',
  '1': 'danger',
};

export const STATUS_NEWS_OPTIONS: Option[] = [
  {
    label: 'Unused', // Unused
    value: `${ENUM_STATUS_NEWS.UNUSED}`,
  },
  {
    label: 'Used', // Used
    value: `${ENUM_STATUS_NEWS.USED}`,
  },
];


export enum ENUM_STATUS_POST {
  INIT = 1,
  IN_PROGRESS = 2,
  FAIL = 3,
  SUCCESS = 4,
  CANCEL = 5,
};

export const COLORS_STATUS_POST: any = {
  [`${ENUM_STATUS_POST.INIT}`]: 'secondary',
  [`${ENUM_STATUS_POST.IN_PROGRESS}`]: 'primary',
  [`${ENUM_STATUS_POST.FAIL}`]: 'danger',
  [`${ENUM_STATUS_POST.SUCCESS}`]: 'success',
  [`${ENUM_STATUS_POST.CANCEL}`]: 'warning',
};

export const STATUS_POST_OPTIONS: Option[] = [
  {
    label: 'Waiting', // Waiting
    value: `${ENUM_STATUS_POST.INIT}`,
  },
  {
    label: 'In Progress', // In Progress
    value: `${ENUM_STATUS_POST.IN_PROGRESS}`,
  },
  {
    label: 'Success', // Success
    value: `${ENUM_STATUS_POST.SUCCESS}`,
  },
  {
    label: 'Fail', // Fail
    value: `${ENUM_STATUS_POST.FAIL}`,
  },
  {
    label: 'Cancel', // Cancel
    value: `${ENUM_STATUS_POST.CANCEL}`,
  },
];


export enum ENUM_SENTIMENT_NEWS {
  POSITIVE = 'Positive',
  NEGATIVE = 'Negative',
  NEUTRAL = 'Neutral',
};

export const COLORS_SENTIMENT_NEWS: any = {
  [`${ENUM_SENTIMENT_NEWS.POSITIVE}`]: 'primary',
  [`${ENUM_SENTIMENT_NEWS.NEGATIVE}`]: 'danger',
  [`${ENUM_SENTIMENT_NEWS.NEUTRAL}`]: 'secondary',
};

export const SENTIMENT_NEWS_OPTIONS: Option[] = [
  {
    label: 'Positive', // Positive
    value: `${ENUM_SENTIMENT_NEWS.POSITIVE}`,
  },
  {
    label: 'Negative', // Negative
    value: `${ENUM_SENTIMENT_NEWS.NEGATIVE}`,
  },
  {
    label: 'Neutral', // Neutral
    value: `${ENUM_SENTIMENT_NEWS.NEUTRAL}`,
  },
];

export const IS_OPTIONS: Option[] = [
  {
    label: "YES",
    value: "1",
  },
  {
    label: "NO",
    value: "0",
  },
];

export const METHOD_OPTIONS: Option[] = [
  {
    label: "GET",
    value: "GET",
  },
  {
    label: "POST",
    value: "POST",
  },
  {
    label: "PUT",
    value: "PUT",
  },
  {
    label: "DELETE",
    value: "DELETE",
  },
];

export const COLOR_TYPE_SENTIMENT: any = {
  'Positive': 'primary',
  'Negative': 'danger',
  'Neutral': 'muted'
}

export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'];

export const CONFIG_ALLOW_SANITIZE_HTML = {
  allowedTags: ['table', 'tr', 'td', 'th', 'tbody', 'thead', 'tfoot'],
  allowedAttributes: {
    '*': ['href', 'src'],
    'table': ['border', 'width', 'cellpadding', 'cellspacing'],
    'td': ['colspan', 'rowspan'],
    'th': ['colspan', 'rowspan']
  },
};

export enum PROVIDER_TYPE {
  DEFAULT = 'default',
  GUEST = 'guest',
  KAKAO = 'kakao',
  NAVER = 'naver',
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
  PRESSCON = 'presscon',
};


export enum AIModel {
  GEMMA2_9B = 'gemma2:9b',
  GEMMA2_27B = 'gemma2:27b',
  GEMMA3_27B = 'gemma3:27b',
  CHATGPT_4o = 'gpt-4o',
}

export const COLORS_AI_MODEL: any = {
  [AIModel.GEMMA2_9B]: 'success',
  [AIModel.GEMMA2_27B]: 'primary',
  [AIModel.GEMMA3_27B]: 'warning',
  [AIModel.CHATGPT_4o]: 'danger',
};

export const AI_MODEL_OPTIONS: Option[] = [
  {
    label: "GEMMA2 9B", // GEMMA2_9B
    value: AIModel.GEMMA2_9B,
  },
  {
    label: "GEMMA2 27B", // GEMMA2_27B
    value: AIModel.GEMMA2_27B,
  },
  {
    label: "GEMMA3 27B", // GEMMA3_27B
    value: AIModel.GEMMA3_27B,
  },
  {
    label: "CHATGPT 4o", // CHATGPT_4o
    value: AIModel.CHATGPT_4o,
  },
];

export enum IMAGE_TYPE {
  ALL = '',
  FAVORITE_IMAGE = '1',
  PUBLIC_IMAGE = '2',
  USED_IMAGE = '3',
  MY_IMAGE = '4',
}

export const TYPE_IMAGE_OPTIONS: Option[] = [
  // {
  //   label: "All",
  //   value: IMAGE_TYPE.ALL,
  // },
  {
    label: "Favorites",
    value: IMAGE_TYPE.FAVORITE_IMAGE,
  },
  {
    label: "Public Images",
    value: IMAGE_TYPE.PUBLIC_IMAGE,
  },
  {
    label: "Used Images",
    value: IMAGE_TYPE.USED_IMAGE,
  },
  {
    label: "My Images",
    value: IMAGE_TYPE.MY_IMAGE,
  },
];


export enum IMAGE_SOURCE {
  PUBLIC_IMAGE = '1',
  MY_IMAGE = '2',
}

export const TYPE_SOURCE_IMAGE_OPTIONS: Option[] = [
  {
    label: "My Images",
    value: IMAGE_SOURCE.MY_IMAGE,
  },
  {
    label: "Public Images",
    value: IMAGE_SOURCE.PUBLIC_IMAGE,
  },
];

export enum SYSTEM_CONFIG_KEY {

  RETRY_COUNT_POST_NEWS = 'post:retry_count',

}

export enum POST_WEBSITE {
  DC_INSIDE = 'dcinside',
  DC_INSIDE_MINOR = 'dcinside_minor',
  DC_INSIDE_MINI = 'dcinside_mini',
  DC_INSIDE_PERSON = 'dcinside_person',
}

export const WEBSITE_POST_OPTIONS: Option[] = [
  {
    label: `dcinside`,
    value: `${POST_WEBSITE.DC_INSIDE}`,
  },
  {
    label: `dcinside minor`,
    value: `${POST_WEBSITE.DC_INSIDE_MINOR}`,
  },
  {
    label: `dcinside mini`,
    value: `${POST_WEBSITE.DC_INSIDE_MINI}`,
  },
  {
    label: `dcinside person`,
    value: `${POST_WEBSITE.DC_INSIDE_PERSON}`,
  }
];

